import React from "react";
import NoRecordFound from "../../../../../../components/ui/noRecordFound/NoRecordFound";
import { useSelfEvaluationInfoContext } from "../Form/SelfEvaluationInfoContext";
import { useRequirementComment } from "../hooks/useRequirementComment";
import { useSectionMaster } from "../hooks/useSectionMaster";
import RequirementCard from "./RequirementCard";

const EMPTY = [];
const RequirementSection = ({ section, title, brandList = null, cardClassName = "", renderHeader }) => {
    const { requirements, fieldsByRequirement, isLoading } = useSectionMaster(section);
    const { state } = useSelfEvaluationInfoContext();
    const { changeComment, saveRequirementComment, savingSelfEvalRequirementId } = useRequirementComment();

    return (
        <div className="section-card">
            <h3 className="section-title">{`Section ${section}`}</h3>
            {renderHeader?.(requirements)}

            {isLoading ? null : requirements.length > 0 ? (
                <div className="evaluation-table-wrapper">
                    {requirements.map((item) => {
                        const reqId = item.sgbpRequirementId;
                        const reqState = state.requirements[reqId];
                        return (
                            <RequirementCard
                                key={reqId}
                                reqId={reqId}
                                item={item}
                                reqState={reqState}
                                fields={fieldsByRequirement[reqId] ?? EMPTY}
                                fieldValues={state.fields}
                                brandList={brandList}
                                className={cardClassName}
                                isSaving={
                                    reqState?.selfEvalRequirementId != null &&
                                    savingSelfEvalRequirementId === reqState.selfEvalRequirementId
                                }
                                onCommentChange={changeComment}
                                onSave={saveRequirementComment}
                            />
                        );
                    })}
                </div>
            ) : (
                <NoRecordFound />
            )}
        </div>
    );
};

export default RequirementSection;